import ApiService from "@/services/apiService";
import RueckrufForm from "./RueckrufForm.vue";
import { createApp } from "vue";

let loginAppContainer = document.getElementById("rueckruf-form");

if(loginAppContainer) {
    ApiService.create();
    const app = createApp(RueckrufForm, { container:loginAppContainer });

    app.mount(loginAppContainer);
}


